import { H4 } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import { ContentWrapper } from './ContentWrapper';

type Link = {
  url: string;
  title: string;
};

const TUTORIAL_LINKS: Array<Link> = [
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360039478431-Referral-Dashboard-for-Sales-Associates-',
    title: 'Tutorial: How to use the Opendoor Referral Dashboard',
  },
];

const OD_UNIVERSITY_LINKS: Array<Link> = [
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360042904532-Selling-to-Opendoor',
    title: 'Selling to Opendoor during Covid-19',
  },
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360040522471-Seller-Benefits-the-3-C-s-1-',
    title: 'Benefits of selling to Opendoor',
  },
  {
    url: 'https://www.opendoor.com/partners/builders',
    title: 'Creating an account',
  },
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360039480531-Reporting-Dashboard-for-Management',
    title: 'Homebuilder Reporting Dashboard ',
  },
];

const LearningCenterSection = () => {
  return (
    <ContentWrapper>
      <ContentCard title="Learning Center" borderRadius="roundedSquare">
        <H4 mb={5}>Tutorials and Webinars</H4>
        <ul>
          {TUTORIAL_LINKS.map((link) => (
            <li key={link.title}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </li>
          ))}
        </ul>
        <H4 my={5}>Opendoor University</H4>
        <ul>
          {OD_UNIVERSITY_LINKS.map((link) => (
            <li key={link.title} style={{ marginBottom: '2px' }}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </li>
          ))}
        </ul>
      </ContentCard>
    </ContentWrapper>
  );
};

export default LearningCenterSection;
